import { render, staticRenderFns } from "./TableEventZone.vue?vue&type=template&id=4b5ca951&scoped=true&"
import script from "./TableEventZone.vue?vue&type=script&lang=js&"
export * from "./TableEventZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ca951",
  null
  
)

export default component.exports